(function () {
  "use strict";

  var CONTAINER_SELECTOR = "#CollectionLoop";
  var PAGINATION_SELECTOR = "#wim-infinite-pagination";
  var PRODUCTS_GRID_SELECTOR = "[data-products-grid]";
  var COLLECTION_SELECTOR = 'collection-component[data-infinite-scroll="true"]';

  var instance = null;
  var gridObserver = null;

  function getProductsGrid() {
    var collection = document.querySelector(COLLECTION_SELECTOR);
    if (!collection) {
      return null;
    }

    return collection.querySelector(PRODUCTS_GRID_SELECTOR);
  }

  function setLoading(loading) {
    var grid = getProductsGrid();
    if (grid) {
      grid.classList.toggle("is-loading", loading);
    }
  }

  function animateNewItems(container) {
    if (!container) {
      return;
    }

    var elements = container.querySelectorAll("[data-aos]:not(.aos-animate)");

    if (!elements.length) {
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, intersectionObserver) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("aos-animate");
            intersectionObserver.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px" },
    );

    elements.forEach(function (element) {
      observer.observe(element);
    });
  }

  function destroyInstance() {
    if (instance && typeof instance.destroy === "function") {
      instance.destroy();
      instance = null;
    }
  }

  function initInfiniteScroll() {
    if (!document.querySelector(COLLECTION_SELECTOR)) {
      return;
    }

    if (typeof Ajaxinate === "undefined") {
      return;
    }

    var container = document.querySelector(CONTAINER_SELECTOR);
    var pagination = document.querySelector(PAGINATION_SELECTOR);

    destroyInstance();

    if (!container || !pagination || !pagination.querySelector("a")) {
      return;
    }

    instance = new Ajaxinate({
      container: CONTAINER_SELECTOR,
      pagination: PAGINATION_SELECTOR,
      method: "scroll",
      callback: function () {
        animateNewItems(container);
      },
    });
  }

  function observeProductsGrid() {
    var grid = getProductsGrid();

    if (!grid || gridObserver) {
      return;
    }

    gridObserver = new MutationObserver(function () {
      window.requestAnimationFrame(initInfiniteScroll);
    });

    gridObserver.observe(grid, { childList: true, subtree: false });
  }

  function onReady() {
    initInfiniteScroll();
    observeProductsGrid();
  }

  document.addEventListener("wim:infinite-scroll:loading", function (event) {
    if (event.detail && typeof event.detail.loading === "boolean") {
      setLoading(event.detail.loading);
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }

  window.WimInfiniteScroll = {
    init: initInfiniteScroll,
    destroy: destroyInstance,
  };
})();
